import { createFileRoute } from "@tanstack/react-router"
import CollectionAnalysisTab from "~/components/collections/tabs/CollectionAnalysisTab"
import { useCollectionContext } from "~/context/CollectionProvider"
import { useVariantContext } from "~/context/VariantProvider"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute(
  "/_auth/demand-planning/fashion/$collectionId/_layout/analysis",
)({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Collection - Analysis")
  const { collections, endDate, startDate } = useCollectionContext()
  const { variants } = useVariantContext()

  if (!startDate || !endDate) return

  return (
    <CollectionAnalysisTab
      collections={collections}
      startDate={startDate}
      endDate={endDate}
      variants={variants}
    />
  )
}
